export enum Vendor {
  DigitalGlue = 'DigitalGlue',
  Prezzee = 'Prezzee',
  Eonx = 'Eonx',
}
